export default {
  rowKey: 'id',
  rowSelection: true,
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 180,
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      render: 'checkPhone',
      width: 160,
    },
    {
      title: '城市',
      dataIndex: 'cityName',
      width: 100,
      ellipsis: true,
    },
    {
      title: '品牌',
      dataIndex: 'channelBrandName',
      width: 120,
      // render: 'businessLineRender',
      ellipsis: true,
    },
 /*   {
      title: '总分归属',
      dataIndex: 'armyAffiliation',
      width: 100,
      render: 'armyAffiliationRender',
      ellipsis: true,
    },*/
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 220,
      ellipsis: true,
    },
 /*   {
      title: '派单方式',
      dataIndex: 'dispatchSceneName',
      width: 140,
      ellipsis: true,
    },*/
    {
      title: '云客服',
      dataIndex: 'seat',
      width: 140,
      ellipsis: true,
    },
    {
      title: '营销员',
      dataIndex: 'sales',
      width: 220,
      ellipsis: true,
    },
    {
      title: '派单类型',
      dataIndex: 'dispatchTypeName',
      width: 140,
      ellipsis: true,
    },
    {
      title: '建筑面积',
      dataIndex: 'constructArea',
      width: 120,
      ellipsis: true,
    },
    {
      title: '创建日期',
      dataIndex: 'createdTime',
      width: 170,
      itemType: 'dateTime',
      ellipsis: true,
    },
    {
      title: '派单日期',
      dataIndex: 'dispatchTime',
      width: 200,
      itemType: 'dateTime',
      ellipsis: true,
    },
    {
      title: '派单重试次数',
      dataIndex: 'dispatchRetryNumber',
      width: 120,
      ellipsis: true,
    },
    {
      title: '失败原因',
      dataIndex: 'dispatchExceptionDesc',
      width: 350,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: '#',
      fixed: 'right',
      width: 160,
      render: 'operationCell',
    },
  ],
  search: [
    {
      name: 'id',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'phone',
      itemType: 'number',
      label: '客户电话',
    },
    {
      name: 'channelBrandId',
      label: '品牌',
      itemType: 'select',
      data: 'businessLines',
      key: 'id',
      labelKey: 'brandName',
      showSearch: 'true',
      events: ['filterOption:filterOption'],
    },
    {
      name: 'channelIds',
      label: '客户来源',
      placeholder: '客户来源',
      itemType: 'tree',
      labelKey: "label",
      key: 'id',
      data: 'channels',
      allowClear: true,
      treeCheckable: true,
    },
    {
      name: 'orgId',
      label: '分公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'advertUserId',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'anchor',
      label: '优化师',
    },
    {
      name: 'cityAreaCode',
      itemType: 'select',
      key: 'regionCode',
      labelKey: 'regionName',
      data: 'cityArea',
      label: '城市',
    },
  ],
  batchActions: [
    {
      label: '继续派单',
      type: 'primary',
      render: 'dispatch',
    },
  ],
}
